export const CONFIG_PER_VALUES = [
  { text: 'Organization', value: 'org' },
  { text: 'Sub-Organizations', value: 'suborgs' },
];

export const PAYMENTS_CONFIG_FIELDS = {
  ENABLE_PAYING_EXPENSES_IF_EXPOSURE_IS_CLOSED: 'enable_paying_expenses_if_exposure_is_closed',
  IS_EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE_ENABLED: 'is_expenses_limit_for_closed_exposure_enabled',
  EXPENSES_LIMIT_FOR_CLOSED_EXPOSURE: 'expenses_limit_for_closed_exposure',
  ENABLE_PAYING_INDEMNITY_IF_EXPOSURE_IS_CLOSED: 'enable_paying_indemnity_if_exposure_is_closed',
  IS_INDEMNITY_LIMIT_FOR_CLOSED_EXPOSURE_ENABLED: 'is_indemnity_limit_for_closed_exposure_enabled',
  INDEMNITY_LIMIT_FOR_CLOSED_EXPOSURE: 'indemnity_limit_for_closed_exposure',
  ENABLE_PAYING_EXPENSES_IF_COVERAGE_ISSUE_EXISTS: 'enable_paying_expenses_if_coverage_issue_exists',
  PREFILL_INDEMNITY_PAYEE_WITH_CLAIMANT: 'prefill_indemnity_payee_with_claimant',
  IS_PAYMENT_METHOD_AUTO_FILL_MAIL_TO_FROM_PAYEE: 'is_payment_method_auto_fill_mail_to_from_payee',
  IS_PREFILL_RESERVE_AMOUNTS_CAPABILITY_ENABLED: 'is_prefill_reserve_amounts_capability_enabled',
  IS_ORG_LEVEL_CONFIGURATION: 'is_org_level_configuration',
  REQUIRE_APPROVAL: 'require_approval_for_every_payment',
  ENABLE_TRUSTED_PAYEE_PAYMENTS: 'enable_trusted_payee_payments',
  SKIP_APPROVAL_FOR_RECORD_ONLY_PAYMENTS: 'skip_approval_for_record_only_payments',
  PRESENT_APPROVAL_SCREEN: 'enable_approval_screen',
  ADDITIONAL_APPROVING_USERS: 'additional_approving_user_ids',
  PRESENT_SUBMISSION_SCREEN: 'enable_submission_screen',
  ADDITIONAL_SUBMITTING_USER_IDS: 'additional_submitting_user_ids',
  ALLOW_MULTIPLE_PENDING_PAYMENT_REQUESTS: 'allow_multiple_pending_payment_requests',
  REQUIRE_VERIFICATION_FOR_CONTACT_FINANCE_EDIT: 'require_verification_for_contact_finance_edit',
  REQUIRE_VERIFICATION_FOR_CONTACT_AU_TFN_EDIT: 'require_verification_for_contact_au_tfn_edit',
  CONTACT_AU_TFN_MANDATORY_COVERAGES: 'contact_au_tfn_mandatory_coverages',
  ENABLE_DUPLICATE_PAYMENTS_VERIFICATION: 'enable_duplicate_payments_verification',
  DUPLICATE_PAYMENTS_LEVEL_OF_VERIFICATION: 'duplicate_payments_level_of_verification',
  DUPLICATE_PAYMENTS_ACTION: 'duplicate_payments_action',
  DUPLICATE_PAYMENTS_VERIFICATION_INITIALIZED: 'duplicate_payments_verification_initialized',
  ALLOW_INDEMNITY_PAYMENTS_ONLY_FOR_EXISTING_PROPERTY_OWNER:
    'allow_indemnity_payments_only_for_existing_property_owner',
  INCLUDE_VAT_IN_PAYMENT_SCREEN: 'include_vat_in_payment_screen',
  INCLUDE_VAT_IN_FINANCES_SUMMARY: 'include_vat_in_finances_summary',
  DISPLAY_NET_AMOUNTS: 'display_net_amounts',
  REDUCE_RESERVES_BY_NET_PAID: 'reduce_reserves_by_net_paid',
  ENABLE_1099_FIELDS: 'enable_1099_fields',
  REQUIRE_TIN_FOR_INDEMNITY_PAYEES: 'require_tin_for_indemnity_payees',
  IS_EXPENSES_SUB_RESERVES_CONFIG_ENABLED: 'is_expenses_sub_reserves_config_enabled',
  IS_MULTIPLE_SUB_RESERVE_PAYMENTS_ENABLED: 'is_multiple_sub_reserve_payments_enabled',
  SHOULD_DISABLE_PAYMENT_EXCEEDING_RESERVE: 'should_disable_payment_exceeding_reserve',
  ENABLE_UK_BANK_ACCOUNT_VALIDATION: 'enable_uk_bank_account_validation',
  ADJUST_RESERVE_INCLUDES_DEDUCTIBLE: 'adjust_reserve_includes_deductible',
  ADJUST_RESERVE_AFTER_PAYMENT_CANCELLATION: 'adjust_reserve_after_payment_cancellation',
  OFAC_CONFIGURATION_ENABLED: 'ofac_configuration_enabled',
  OFAC_FUZZY_MATCH_ENABLED: 'ofac_fuzzy_match_enabled',
  OFAC_FUZZY_MATCH_SCORE: 'ofac_fuzzy_match_score',
  OFAC_IS_SEND_ADDRESS_FIELDS_ENABLED: 'ofac_is_send_address_fields_enabled',
  IS_ANTICIPATED_AMOUNT_INCLUDED_IN_RECOVERIES_CALC: 'is_anticipated_amount_included_in_recoveries_calc',
  DISABLE_ADJUSTER_MODIFYING_SELF_PAYMENT_LIMITS: 'disable_adjuster_modifying_self_payment_limits',
  ALLOW_CLAIM_MULTI_CURRENCY: 'allow_claim_multi_currency',
  MULTI_CURRENCY_CONFIGURATION: 'multi_currency_configuration',
  IS_GENERAL_RECOVERIES_ENABLED: 'is_general_recoveries_enabled',
  GENERAL_RECOVERIES_CONFIGURATION: 'general_recoveries_configuration',
  ENABLE_SPLIT_GENERAL_RECOVERY: 'enable_split_general_recovery',
  CAP_RECOVERIES_AT_TOTAL_PAID: 'cap_recoveries_at_total_paid',
  IS_RECOVERIES_INCLUDED_IN_INCURRED_CALC: 'is_recoveries_included_in_incurred_calc',
  IS_SPLIT_ROUTING_ENABLED: 'is_split_routing_enabled',
};

export const CAP_RECOVERIES_MODES = {
  OFF: 'off',
  WARN: 'warn',
  BLOCK: 'block',
};

export const CAP_RECOVERIES_MODE_OPTIONS = [
  { optionValue: CAP_RECOVERIES_MODES.WARN, text: 'Warn (require confirmation with reason)' },
  { optionValue: CAP_RECOVERIES_MODES.BLOCK, text: 'Block (prevent save)' },
];

export const isCapEnforcementOn = (mode) => mode === CAP_RECOVERIES_MODES.WARN || mode === CAP_RECOVERIES_MODES.BLOCK;
